import { BRAND_REORDER_EXCLUSIONS_UPDATE } from "constants/action-types";

export const updateReorderExclusions = (exclusions: string[]) => ({
    payload: exclusions,
    type: BRAND_REORDER_EXCLUSIONS_UPDATE,
});
